module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('base-modal', {
    attrs: {
      "title": "DELETE FOLDER",
      "id": _vm.id,
      "value": _vm.value,
      "extra-class": "modal-sm"
    },
    on: {
      "shown": _vm.clear,
      "input": function($event) {
        return _vm.$emit('input', $event)
      }
    },
    scopedSlots: _vm._u([{
      key: "footer",
      fn: function() {
        return [_c('button', {
          staticClass: "btn green mt-ladda-btn ladda-button remove-participant-control",
          attrs: {
            "data-dismiss": "modal",
            "data-style": "expand-left"
          },
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.deleteFolderAction({
                'folderId': _vm.folderId,
                'deleteFolderContent': _vm.deleteFolderContent
              })
            }
          }
        }, [_c('span', {
          staticClass: "ladda-label"
        }, [_vm._v("Yes")])]), _vm._v(" "), _c('button', {
          staticClass: "btn default",
          attrs: {
            "data-dismiss": "modal"
          }
        }, [_vm._v("Cancel")])]
      },
      proxy: true
    }])
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('p', [_vm._v("Are you sure you would like to delete this folder?")])])]), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    staticClass: "mt-checkbox mt-checkbox-outline"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.deleteFolderContent),
      expression: "deleteFolderContent"
    }],
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "value": 1,
      "checked": Array.isArray(_vm.deleteFolderContent) ? _vm._i(_vm.deleteFolderContent, 1) > -1 : (_vm.deleteFolderContent)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.deleteFolderContent,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = 1,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.deleteFolderContent = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.deleteFolderContent = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.deleteFolderContent = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span'), _vm._v("\n      Delete existing reports and subfolders")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-8025e76c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/reports/DeleteFolderModal.vue
// module id = 1714
// module chunks = 1